import { render } from "./EditEntireDetailsForm.vue?vue&type=template&id=023a1b4a"
import script from "./EditEntireDetailsForm.vue?vue&type=script&lang=js"
export * from "./EditEntireDetailsForm.vue?vue&type=script&lang=js"

import "./EditEntireDetailsForm.vue?vue&type=style&index=0&id=023a1b4a&lang=css"
import "./EditEntireDetailsForm.vue?vue&type=style&index=1&id=023a1b4a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__